const defaultLinks = [
  { name: "Call Log", path: "/callLog" },
  { name: "Orders History", path: "/orders" },
  { name: "Take Orders", path: "/take-order" },
  { name: "Drivers", path: "/driver" },
  { name: "Online Ordering", path: "/online-ordering" },
  { name: "Table", path: "/floor" },
  { name: "Reservation", path: "/reservation" },
  { name: "Loyalty-Offer", path: "/loyalty" },
  { name: "Table-Side Self Ordering", path: "/table-side-ordering" },
  { name: "Resbook", path: "/resbook" },
  { name: "Marketing", path: "/marketing", isNew: true },
  { name: "Admin Settings", path: "/admin-settings" },
  { name: "Dashboard", path: "/dashboard/overview" },
  { name: "Back Office", path: "/back-office" },
  { name: "Kiosk", path: "/kiosk", isNew: true },
];

const loyaltyLinks = [
  {
    title: "Overview",
    icon: <LuLayoutDashboard />,
    path: "/loyalty/overview"
  },
  {
    title: "Loyalty",
    path: "/loyalty/gift-card",
    icon: <MdOutlineLoyalty />,
    children: [
      { title: "Gift Card",path: "/loyalty/gift-card"},
      { title: "Voucher", path: "/loyalty/voucher" },
      { title: "C2C Gift Card", path: "/loyalty/c2c-voucher" },
      { title: "Concession", path: "/loyalty/concession" },
      { title: "Point-Based Reward", path: "/loyalty/point-based" },
      { title: "Template", path: "/loyalty/template" },

    ],
  },
  {
    title: "Offers",
    path: "/loyalty/gift-card",
    icon: <MdOutlineLocalOffer />,
    children: [
      {
        title: "Buy & Get Item",
        path: "/offer/buy-get-item",
        permission: [
          "loyalty_offer.get_item_offer.offer_list",
          "loyalty_offer.get_item_offer",
        ],
      },
      {
        title: "Buy & Get Discount",
        path: "/offer/buy-get-discount",
        permission: "loyalty_offer.get_discount_offer",
      },
      {
        title: "Spend Over & Get Item",
        path: "/offer/spend-over-get-item",
        permission: [
          "loyalty_offer.spend_item_offer.offer_list",
          "loyalty_offer.spend_item_offer",
        ],
      },
      {
        title: "Spend & Get Discount",
        path: "/offer/spend-get-discount",
        permission: "loyalty_offer.spend_discount_offer",
      },
      {
        title: "Online Order Discount",
        path: "/offer/online-order-get-discount",
        permission: "loyalty_offer.order_online_discount_offer",
      },
      { title: "Download App Discount", path: "/offer/app-download-get-discount" },

    ],
  },

];

import {
  AiOutlineHome,
  AiOutlineUser,
  AiOutlineBarChart,
  AiOutlineShopping,
  AiOutlineDollarCircle,
  AiOutlineBook,
  AiOutlineBank,
  AiOutlineTeam,
  AiOutlineRise,
  AiOutlineShop,
  AiOutlineGlobal,
  AiOutlineQrcode,
  AiOutlineSetting,
  AiOutlineHistory,
} from "react-icons/ai";
import { IoIosNotificationsOutline } from "react-icons/io";
import {
  GlassWater,
  UtensilsCrossed,
  IceCream,
  Sandwich,
  Coffee,
  Ham,
  Pizza,
  Fish,
  Layers,
  Star,
  Tag,
  Wine,
  Settings,
  Armchair,
  Users,
  ArrowLeftRight,
  Tablet,
  QrCode,
  Shuffle,
  Sparkles,
} from "lucide-react";
import { SettingsIcon } from "../icons/SVG";
import { MdOutlineLocalOffer, MdOutlineLoyalty } from "react-icons/md";
import { LuLayoutDashboard } from "react-icons/lu";

const tableSideOrderingLinks = [
  {
    title: "Customer Self Order",
    icon: <Tablet size={18} />,
    path: "/table-side-ordering/customer-self-order",
  },
  {
    title: "QR Code Order",
    icon: <QrCode size={18} />,
    path: "/table-side-ordering/qr-code-order",
  },
];

const backofficeLinks = [
  { title: "Overview", icon: <AiOutlineHome />, path: "/backoffice/overview" },
  // { title: 'Owner Profile', icon: <AiOutlineUser />, path: '/owner-profile' },
  // {
  //   title: "Reports & Analytics",
  //   icon: <AiOutlineBarChart />,
  //   path: "/reports-analytics",
  // },
  {
    title: "Customer",
    icon: <Users size={18} />,
    path: "/backoffice/customer",
    permission: "back_office.customer.customer_list"
  },
  {
    title: "Till To Till Share",
    icon: <ArrowLeftRight size={18} />,
    path: "/backoffice/till-to-till-share",
    permission: "back_office.till_to_till_share"
  },
  // {
  //   title: "Stock & Inventory",
  //   icon: <AiOutlineShopping />,
  //   path: "/stock-inventory",
  // },
  {
    title: "Notifications",
    icon: <IoIosNotificationsOutline size={24} />,
    path: "",
    permission: "back_office.notification",
    children: [
      {
        title: "General Notifications",
        icon: <GlassWater />,
        path: "/backoffice/notification",
        permission: "back_office.notification.general_notification"
      },
      {
        title: "Online Notifications",
        icon: <GlassWater />,
        path: "/backoffice/online-notification",
        permission: "back_office.notification.online_notificaion"
      }
    ],
  },
  {
    title: "Cost Management",
    icon: <AiOutlineDollarCircle />,
    path: "/cost-management",
    permission: "back_office.cost_management",
    children: [
      {
        title: "Complementary Report",
        icon: <GlassWater />,
        path: "/backoffice/cost-management/complementary-report",
        permission: "back_office.cost_management.complementary_report"
      },
      {
        title: "Replace Item (Eat-In / Table) Report",
        icon: <GlassWater />,
        path: "/backoffice/cost-management/table-replace-item-report",
        permission: "back_office.cost_management.table_replace_item_report"
      },
      {
        title: "Replace Item (Takeaway) Report",
        icon: <GlassWater />,
        path: "/backoffice/cost-management/take-away-replace-item-report",
        permission: "back_office.cost_management.take_away_replace_item_report"
      },
      {
        title: "SMS Using History",
        icon: <GlassWater />,
        path: "/backoffice/cost-management/sms-usage-history",
        // permission: "back_office.cost_management.sms_usage_history"
      },
    ],
  },
  {
    title: "Menu Management",
    icon: <AiOutlineBook />,
    path: "/menu-management",
    permission: "back_office.menu_management",
    children: [
      {
        title: "Overview",
        icon: <AiOutlineHome />,
        path: "/backoffice/menu/overview",
        permission: "back_office.menu_management.overview"
      },
      {
        title: "Drinks",
        icon: <GlassWater />,
        path: "/backoffice/menu/drinks",
        permission: "back_office.menu_management.list_drinks"
      },
      {
        title: "Standard Foods",
        icon: <UtensilsCrossed />,
        path: "/backoffice/menu/standard-foods",
        permission: "back_office.menu_management.list_standard_food"
      },
      {
        title: "Dessert",
        icon: <IceCream />,
        path: "/backoffice/menu/dessert",
        permission: "back_office.menu_management.list_dessert"
      },
      {
        title: "Tea & Coffee",
        icon: <Coffee />,
        path: "/backoffice/menu/tea-coffee",
        permission: "back_office.menu_management.list_tea_coffee"
      },
      {
        title: "Pizza",
        icon: <Pizza />,
        path: "/backoffice/menu/pizza",
        permission: "back_office.menu_management.list_pizza"
      },
      {
        title: "Burger",
        icon: <Sandwich />, path: "/backoffice/menu/burger",
        permission: "back_office.menu_management.list_burger"
      },
      {
        title: "Kebab",
        icon: <Ham />,
        path: "/backoffice/menu/kebab",
        permission: "back_office.menu_management.list_kebab"
      },
      {
        title: "Fish & Chips",
        icon: <Fish />,
        path: "/backoffice/menu/fish-chips",
        permission: "back_office.menu_management.list_fish_chips"
      },
      {
        title: "Combo Meal",
        icon: <Layers />,
        path: "/backoffice/menu/combo-meal",
        permission: "back_office.menu_management.list_combo_meal"
      },
      {
        title: "Course",
        icon: <Tag />,
        path: "/backoffice/menu/course",
        permission: "back_office.menu_management.list_course"
      },
      {
        title: "Mix & Match",
        icon: <Shuffle size={18} />,
        path: "/backoffice/menu/mix-and-match",
        permission: "back_office.menu_management.list_mix_and_match"
      },
      {
        title: "Choose Your Own",
        icon: <Sparkles size={18} />,
        path: "/backoffice/menu/create-your-own-general",
        permission: "back_office.menu_management.overview"
      },
      // {
      //   title: "Meal Offer",
      //   icon: <Tag />,
      //   path: "/backoffice/menu/meal-offer",
      // },
      // {
      //   title: "Drinks Offer",
      //   icon: <Wine />,
      //   path: "/backoffice/menu/drinks-offer",
      // },
      {
        title: "Special Menu",
        icon: <Star />,
        path: "/backoffice/menu/special-menu/dish-the-day",
        permission: "back_office.menu_management.list_special_menu"
      },
      {
        title: "Manage Essential",
        icon: <Settings />,
        path: `/backoffice/menu/essentail-menu/drinks/${1}`,
        permission: "back_office.menu_management.overview"
      },
    ],
  },
  // {
  //   title: "Business Management",
  //   icon: <AiOutlineBank />,
  //   path: "/business-management",
  // },
  {
    title: "Staff Management",
    icon: <AiOutlineTeam />,
    path: "/staff-management",
    permission: "back_office.staff_management",
    children: [
      {
        title: "All Staff",
        path: "/backoffice/staff-management/staff/all",
        permission: "back_office.staff_management.staff_list",
      },
      {
        title: "Role Access",
        path: "/backoffice/staff-management/role-access",
        permission: "back_office.staff_management.role_access",
      },
      {
        title: "Payroll", path: "/backoffice/staff-management/payroll",
        permission: "back_office.staff_management.staff_payroll",
      },
      {
        title: "Shift Schedule",
        path: "/backoffice/staff-management/shift-schedule",
        permission: "back_office.staff_management.shift_schedule",
      },

      {
        title: "Staff Reports",
        path: "/backoffice/staff-management/staff-reports",
        permission: "back_office.staff_management.staff_reports",
      },

      {
        title: "Holidays", path: "/backoffice/staff-management/holidays",
        permission: "back_office.staff_management.holidays",
      },
      {
        title: "Leave Settings",
        path: "/backoffice/staff-management/leaves-settings",
        permission: "back_office.staff_management.leave_settings",
      },
      {
        title: "Time Sheet", path: "/backoffice/staff-management/time-sheet",
        // permission: "back_office.staff_management.staff_list",
      },
    ],
  },
  // {
  //   title: "Business Development",
  //   icon: <AiOutlineRise />,
  //   path: "/business-development",
  // },
  // {
  //   title: "Out-Let Management",
  //   icon: <AiOutlineShop />,
  //   path: "/outlet-management",
  // },
  {
    title: "Settings",
    icon: <AiOutlineSetting />,
    path: "/settings",
    permission: "back_office.settings",
    children: [
      {
        title: "Sound Settings",
        path: "/backoffice/settings/sounds-settings",
        permission: "back_office.settings.general_settings",
      },
      {
        title: "Delivery Management",
        path: "/backoffice/settings/delivery-management",
        permission: "back_office.settings.delivery_management",
      },
      {
        title: "Take Order Settings",
        path: "/backoffice/settings/take-order-settings",
        permission: "back_office.settings.take_order_settings"
      },
      {
        title: "Discount Management",
        path: "/backoffice/settings/discount",
        permission: "back_office.settings.discount_management"
      },
      {
        title: "Points - Reward Settings",
        path: "/backoffice/settings/points-reward-settings",
        permission: "back_office.settings.point_reward_settings"
      },
      {
        title: "Device Management",
        path: "/backoffice/settings/device-management",
        permission: "back_office.settings.device_management"
      },
      {
        title: "Floor & Room Management",
        icon: <Armchair />,
        path: "/backoffice/table-floor-plan",
        permission: "back_office.settings.floor_plan"
      },
      {
        title: "Printer Management", path: "/backoffice/printer-management",
        permission: "back_office.settings.printer_management"
      },
      {
        title: "Receipt Management", path: "/backoffice/receipt-management",
        permission: "back_office.settings.receipt_management"
      },
    ],
  },
];

const backOfficeAdminLink = [
  { title: "Dashboard", path: "/admin/dashboard" },
  { title: "Client", path: "/admin/client" },
  { title: "Quick Sign Up", path: "/admin/quick-signup" },
  { title: "Lead", path: "/admin/lead" },
  { title: "Hot Lead", path: "/admin/hot-lead" },
  { title: "In progress", path: "/admin/in-progress" },
  { title: "Employee", path: "/admin/employee" },
  { title: "Finance", path: "/admin/finance" },
  { title: "Business", path: "/admin/business" },
  { title: "Outlet", path: "/admin/outlet" },
  { title: "Module & Permission", path: "/admin/module-permission" },
  { title: "Settings", path: "/admin/settings" },
  { title: "Knowledge", path: "/admin/knowledge" },
  { title: "After Sale Service", path: "/admin/after-sale-service" },
];

const essentialMenuItem = [
  { title: "Drinks", path: "/backoffice/menu/essentail-menu/drinks", id: 1 },
  {
    title: "Standard Foods",
    path: "/backoffice/menu/essentail-menu/standard-foods",
    id: 2,
  },
  { title: "Dessert", path: "/backoffice/menu/essentail-menu/dessert", id: 3 },
  {
    title: "Tea & Coffee",
    path: "/backoffice/menu/essentail-menu/tea-coffee",
    id: 4,
  },
  { title: "Pizza", path: "/backoffice/menu/essentail-menu/pizza", id: 5 },
  { title: "Burger", path: "/backoffice/menu/essentail-menu/burger", id: 6 },
  { title: "Kebab", path: "/backoffice/menu/essentail-menu/kebab", id: 7 },
  {
    title: "Fish & Chips",
    path: "/backoffice/menu/essentail-menu/fish-chips",
    id: 8,
  },
  {
    title: "Combo Meal",
    path: "/backoffice/menu/essentail-menu/combo-meal",
    id: 9,
  },
  {
    title: "Special Menu",
    path: "/backoffice/menu/essentail-menu/special-menu",
    id: 13,
  },
  // {
  //   title: "Meal Offer",
  //   path: "/backoffice/menu/essentail-menu/meal-offer",
  //   id: 11,
  // },
  // {
  //   title: "Drinks Offer",
  //   path: "/backoffice/menu/essentail-menu/drinks-offer",
  //   id: 12,
  // },
];
const availableItemsTabs = [
  { title: "Drinks", path: "drinks", id: 1 },
  {
    title: "Standard Foods",
    path: "standard-foods",
    id: 2,
  },
  { title: "Dessert", path: "dessert", id: 3 },
  {
    title: "Tea & Coffee",
    path: "tea-coffee",
    id: 4,
  },
  { title: "Pizza", path: "pizza", id: 5 },
  { title: "Burger", path: "burger", id: 6 },
  { title: "Kebab", path: "kebab", id: 7 },
  {
    title: "Fish & Chips",
    path: "fish-chips",
    id: 8,
  },
  {
    title: "Combo Meal",
    path: "combo-meal",
    id: 9,
  },
  // {
  //   title: "Special Menu",
  //   path: "special-menu",
  //   id: 13,
  // },
  // {
  //   title: "Meal Offer",
  //   path: "meal-offer",
  //   id: 11,
  // },
  // {
  //   title: "Drinks Offer",
  //   path: "drinks-offer",
  //   id: 12,
  // },
];
const websiteSettingsTabs = [
  { title: "Logo & Banner", path: "logo-banner", id: 1 },
  {
    title: "About",
    path: "about",
    id: 2,
  },
  { title: "Contact Us", path: "contact-us", id: 3 },
  {
    title: "Terms & Conditions",
    path: "trams-conditions",
    id: 4,
  },
  { title: "Availability", path: "available-time", id: 5 },
  { title: "Card", path: "card-settings", id: 6 },
];

const onlineOrderingLinks = [
  {
    title: "Website Ordering",
    icon: <AiOutlineGlobal />,
    path: "/website-ordering",
    children: [
      {
        title: "Order Request",
        icon: "",
        path: "/onlineordering/website-ordering/order-request",
      },
      {
        title: "Order Status",
        icon: "",
        path: "/onlineordering/website-ordering/order-status",
      },
      {
        title: "Available Item",
        icon: "",
        path: `/onlineordering/website-ordering/available-item`,
      },
      {
        title: "Invoice & Statement",
        icon: "",
        path: "/onlineordering/website-ordering/invoice-statement",
      }
    ],
  },
  {
    title: "QR Code Ordering",
    icon: <AiOutlineQrcode />,
    path: "/qr-code-ordering",
    children: [
      // {
      //   title: "Order Request",
      //   icon: "",
      //   path: "/onlineordering/qr-code-ordering/qr-order-request",
      // },
      // {
      //   title: "Order Status",
      //   icon: "",
      //   path: "/onlineordering/qr-code-ordering/qr-order-status",
      // },
      // {
      //   title: "Available Item",
      //   icon: "",
      //   path: "/onlineordering/qr-code-ordering/qr-available-item",
      // },
      {
        title: "QR Code",
        icon: "",
        path: "/onlineordering/qr-code/general",
      },
      {
        title: "SMART QR Code",
        icon: "",
        path: "/onlineordering/qr-code/smart-ordering",
      },
    ],
  },
  {
    title: "Online Order History",
    icon: <AiOutlineHistory />,
    path: "/onlineordering/online-order-history",
  },
  {
    title: "Settings",
    icon: <AiOutlineSetting />,
    path: "/settings",
    children: [
      {
        title: "Website Settings",
        icon: "",
        path: "/onlineordering/settings/website-settings",
      },
      {
        title: "Notice",
        icon: "",
        path: "/onlineordering/settings/notice",
      },
      {
        title: "Temporary Disable",
        icon: "",
        path: "/onlineordering/settings/temporary-disable",
      },
      {
        title: "Order Acceptability",
        icon: "",
        path: "/onlineordering/settings/order-acceptability",
      },
      {
        title: "Reservations Deposit",
        icon: "",
        path: "/onlineordering/settings/reserve-order-settings",
      },
      {
        title: "Till Order Access",
        icon: "",
        path: "/onlineordering/settings/till-order-access",
      },
      {
        title: "Order Settings",
        icon: "",
        path: "/onlineordering/settings/online-order-settings",
       },
    ]
  }
];

const reservationLinks = [
  {
    title: "Reservation Request",
    path: "/reservation/reservation-request-list",
    matchPaths: ["/reservation/rq-details"],
    id: 2,
  },
  { title: "Reservation List", path: "/reservation", id: 1 },
];

const dashboardLinks = [
  {
    title: "Overview",
    path: "/dashboard/overview",
    id: 1,
    permission: "dashboard",
  },
  {
    title: "Reports & Analytics",
    path: "/dashboard/revenue-reports",
    id: 2,
    children: [
      {
        title: "Revenue Report",
        path: "/dashboard/revenue-reports",
        permission: "dashboard.reports.revenue_report",
      },
      {
        title: "Call Log Report",
        path: "/dashboard/call-log-reports",
        permission: "dashboard.reports.call_log_report",
      },
      {
        title: "Order Report",
        path: "/dashboard/order-reports",
        permission: "dashboard.reports.order_report",
      },
      {
        title: "Reservation Report",
        path: "/dashboard/reservation-reports",
        permission: "dashboard.reports.reservation_report",
      },
      {
        title: "Table Report",
        path: "/dashboard/table-reports",
        permission: "dashboard.reports.table_report",
      },
      {
        title: "Loyalty & Offer",
        path: "/dashboard/loyalty-reports",
        permission: "dashboard.reports.loyalty_report",
      },
      {
        title: "Staff Report",
        path: "/dashboard/staff-reports",
        permission: "dashboard.reports.staff_report",
      },
      {
        title: "Menu Management Report",
        path: "/dashboard/menu-reports",
        permission: "dashboard.reports.menu_report",
      },
    ],
  },
];

export {
  defaultLinks,
  essentialMenuItem,
  loyaltyLinks,
  backofficeLinks,
  backOfficeAdminLink,
  onlineOrderingLinks,
  availableItemsTabs,
  websiteSettingsTabs,
  reservationLinks,
  dashboardLinks,
  tableSideOrderingLinks,
};
